export default __webpack_public_path__ + "static/media/caza1.5209d594.svg";